import React, { createContext, useContext } from "react";
import { compose, branch } from "recompose";

const ContributionModeContext = createContext({
  isContributionModeEnabled: false,
});

export const ContributionModeProvider = ({ children }) => {
  return (
    <ContributionModeContext.Provider
      value={{
        isContributionModeEnabled: Boolean(
          typeof window !== "undefined" &&
            window.__CONTRIBUTION_MODE_DATA__?.isContributionModeEnabled
        ),
      }}
    >
      {children}
    </ContributionModeContext.Provider>
  );
};

const useIsContributionModeEnabled = () => {
  const context = useContext(ContributionModeContext);

  return context.isContributionModeEnabled;
};

export const branchContributionModeEnabled = (
  HocContributionModeEnabledComponent,
  HocContributionModeDisabledComponent
) => {
  return compose(
    (BaseComponent) => {
      return (props) => {
        const isContributionModeEnabled = useIsContributionModeEnabled();
        return (
          <BaseComponent
            {...props}
            isContributionModeEnabled={isContributionModeEnabled}
          />
        );
      };
    },
    branch(
      (props) => {
        return props.isContributionModeEnabled;
      },
      HocContributionModeEnabledComponent,
      HocContributionModeDisabledComponent
    )
  );
};
